import { NEAR_NETWORK } from "../config/constants"

export const SONG_COIN_DOMAINS = {
  testnet: 'mzicmizr.testnet',
  mainnet: '',
}

export const SONG_COIN_DOMAIN = SONG_COIN_DOMAINS[NEAR_NETWORK]
